import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import tab from './tab'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    token: localStorage.getItem('token') || '',
    // 功能权限
    FuncPermission: JSON.parse(localStorage.getItem('FuncPermission')) || [],
    // 数据权限
    DataPermission: JSON.parse(localStorage.getItem('DataPermission')) || [],
    // 用户名
    // uName:localStorage.getItem('uName')||''
    // 企业查询结果
    // firmSearchResult:JSON.parse(sessionStorage.getItem('firmSearchResult'))||{}
    /////////////重点企业分析开始///////////////
    // 趋势Time
    trendTime: [],
    // 商标详情数据
    sbbasicDataDetails: [],
    //报告详情数据
    ReportDataDetails: [],
    // 专利详情数据
    zlbasicDataDetails: [],
    // 企业详情数据
    enterbasicDataDetails: [],
    // 国内专利趋势
    trendApListX: [],
    trendApListYapply: [],
    trendApListYagree: [],
    // 专利类型构成
    apTyCount: [],
    apTyAuthCount: [],
    // 专利分析榜单
    appTop10X: [],
    appTop10Y: [],
    authTop10X: [],
    authTop10Y: [],
    validTop10X: [],
    validTop10Y: [],
    notValidTop10X: [],
    notValidTop10Y: [],
    // IPC分类top10
    pctIpcTop10X: [],
    pctIpcTop10Y: [],
    // PCT专利趋势
    pctTrendCountX: [],
    pctTrendCountY: [],
    // IPC技术分类top10
    ipcCountX: [],
    ipcCountY: [],
    ipcAuthCountX: [],
    ipcAuthCountY: [],
    // PCT公开量Top10
    pctTop10CountX: [],
    pctTop10CountY: [],
    // 专利状态分析
    ptLawCount: [],
    // 国内商标趋势
    tmTrendMapY1: [],
    tmTrendMapY2: [],
    // 国际分类Top10
    icTop10MapX: [],
    icTop10MapY: [],
    icRegTop10MapX: [],
    icRegTop10MapY: [],
    // 商标分析榜单
    topApp10MapX: [],
    topApp10MapY: [],
    topReg10MapX: [],
    topReg10MapY: [],
    topValid10MapX: [],
    topValid10MapY: [],
    // 商标状态分析
    lawMap: [],
    // 商标转让趋势
    tmTransferMapY: [],
    // 商标转让类别Top10
    tmIcTrfTopX: [],
    tmIcTrfTopY: [],
    // 商标许可趋势
    tmLicenseMapY: [],
    // 商标许可类别Top10
    tmIcLicTopX: [],
    tmIcLicTopY: [],
    // 商标质押趋势
    tmPledgeMapY: [],
    // 商标质押类别Top10
    tmIcPldTopX: [],
    tmIcPldTopY: [],
    // 商标运营分析榜单
    tmTrfTop10X: [],
    tmTrfTop10Y: [],
    tmLicTop10X: [],
    tmLicTop10Y: [],
    tmPldTop10X: [],
    tmPldTop10Y: [],
    // 马德里商标趋势
    mdltrendY: [],
    // 马德里延伸国家TOP20
    mdltop20X: [],
    mdltop20Y: [],
    // 马德里注册量Top10
    mdlregY: [],
    mdlregX: [],
    /////////////重点企业分析结束///////////////
    /////////////专利分析开始///////////////
    // 国内专利趋势
    trendTimezl: [],
    trendApListzlY1: [],
    trendApListzlY2: [],
    // 专利类型构成
    apTyCountzl: [],
    apTyAuthCountzl: [],
    // 申请人构成及趋势
    jggroup: [],
    dzschool: [],
    sciencedw: [],
    gkcompany: [],
    single: [],
    jggroupAuth: [],
    dzschoolAuth: [],
    sciencedwAuth: [],
    gkcompanyAuth: [],
    singleAuth: [],
    // IPC技术分类Top10
    ipcCountXzl: [],
    ipcCountYzl: [],
    ipcAuthCountXzl: [],
    ipcAuthCountYzl: [],

    // 有效专利申请人分布
    apValid: [],
    utilityValidInvzl: [],
    designValidInvzl: [],
    jggroupAuthYX: [],
    dzschoolAuthYX: [],
    sciencedwAuthYX: [],
    gkcompanyAuthYX: [],
    singleAuthYX: [],
    // 国内专利分析榜单
    appTop10Xzl: [],
    appTop10Yzl: [],
    authTop10Xzl: [],
    authTop10Yzl: [],
    validTop10Xzl: [],
    validTop10Yzl: [],
    notValidTop10Xzl: [],
    notValidTop10Yzl: [],
    // 专利质押登记量趋势 专利核准转让量趋势 专利许可备案量趋势
    // patentPledgeOneX:[],
    patentPledgeOneY: [],
    // patentAssignmentsTwoX:[],
    patentAssignmentsTwoY: [],
    // patentlicensethreeX:[],
    patentlicensethreeY: [],
    // PCT专利趋势
    pctTrendCountYzl: [],
    // IPC分类Top10
    pctIpcTop10Xzl: [],
    pctIpcTop10Yzl: [],
    // PCT公开量Top10
    pctTop10CountXzl: [],
    pctTop10CountYzl: [],
    // 专利状态分析
    ptLawCountzl: [],
    // 区域
    ApplyXzl: [],
    ApplyFM: [],
    ApplySY: [],
    ApplyWG: [],
    AuthXzl: [],
    AuthFM: [],
    AuthSY: [],
    AuthWG: [],
    pctXzl: [],
    pctFM: [],
    pctSY: [],
    wxXzl: [],
    wxFM: [],
    wxSY: [],
    wxWG: [],
    /////////////专利分析结束///////////////
    /////////////商标分析开始///////////////
    trendTimesb: [],
    // 国内商标趋势
    trendApListsbY1: [],
    trendApListsbY2: [],
    // 国际分类Top10
    icTop10MapsbX: [],
    icTop10MapsbY: [],
    icRegTop10MapsbX: [],
    icRegTop10MapsbY: [],
    // 申请人构成及趋势
    jggroupsb: [],
    dzschoolsb: [],
    sciencedwsb: [],
    gkcompanysb: [],
    singlesb: [],
    jggroupAuthsb: [],
    dzschoolAuthsb: [],
    sciencedwAuthsb: [],
    gkcompanyAuthsb: [],
    singleAuthsb: [],
    // 商标分析榜单
    topApp10MapXsb: [],
    topApp10MapYsb: [],
    topReg10MapXsb: [],
    topReg10MapYsb: [],
    topValid10MapXsb: [],
    topValid10MapYsb: [],
    // 商标状态分析
    lawMapSb: [],
    // 区域
    areaTmCompMapX: [],
    areaTmCompMapY: [],
    areaRegTmCompMapX: [],
    areaRegTmCompMapY: [],
    areaMadridTmCompMapX: [],
    areaMadridTmCompMapY: [],
    // 商标运营分析
    tmTransferMapYsb: [],
    tmIcTrfTopXsb: [],
    tmIcTrfTopYsb: [],
    tmLicenseMapYsb: [],
    tmIcLicTopXsb: [],
    tmIcLicTopYsb: [],
    tmPledgeMapYsb: [],
    tmIcPldTopXsb: [],
    tmIcPldTopYsb: [],
    // 商标运营分析榜单
    tmTrfTop10Xsb: [],
    tmTrfTop10Ysb: [],
    tmLicTop10Xsb: [],
    tmLicTop10Ysb: [],
    tmPldTop10Xsb: [],
    tmPldTop10Ysb: [],
    // 代理机构数量分布
    agentDist: [],
    // 商标代理量Top10
    agentTmTop10X: [],
    agentTmTop10Y: [],
    // 非正常商标申请人分布
    malice: [],
    // 非正常申请商标申请量Top10
    maliceAppTmTop10Y: [],
    maliceAppTmTop10X: [],
    // 马德里商标趋势
    mdltrendYsb: [],
    // 马德里延伸国家TOP20
    mdltop20Xsb: [],
    mdltop20Ysb: [],
    // 马德里注册量Top10
    mdlregYsb: [],
    mdlregXsb: [],
    /////////////商标分析结束///////////////
    ///////////////重点产业开始/////////////
    // 趋势Time
    trendTimeind: [],
    // 国内专利趋势
    trendApListXind: [],
    trendApListYapplyind: [],
    trendApListYagreeind: [],
    // 首页专利数据
    // 申请量
    ptApplydataYapplyind: [],
    // 授权量 商标
    ptAuthorizationLine: [],
    tmApplyMonth: [],
    tmApplyNum: [],
    tmRegNum: [],
    // 商标分类注册量
    tmIcApplyIc: [],
    tmIcRegIc: [],
    tmIcApplyNum: [],
    tmIcRegNum: [],

    // 月份
    ptApplydataYagreeind: [],
    // 专利类型构成
    apTyCountind: [],
    apTyAuthCountind: [],
    // 专利分析榜单
    appTop10Xind: [],
    appTop10Yind: [],
    authTop10Xind: [],
    authTop10Yind: [],
    validTop10Xind: [],
    validTop10Yind: [],
    notValidTop10Xind: [],
    notValidTop10Yindind: [],
    // IPC分类top10
    pctIpcTop10Xind: [],
    pctIpcTop10Yind: [],
    // PCT专利趋势
    pctTrendCountXind: [],
    pctTrendCountYind: [],
    // IPC技术分类top10
    ipcCountXind: [],
    ipcCountYind: [],
    ipcAuthCountXind: [],
    ipcAuthCountYind: [],
    // PCT公开量Top10
    pctTop10CountXind: [],
    pctTop10CountYind: [],
    // 专利状态分析
    ptLawCountind: [],
    // 国内商标趋势
    tmTrendMapY1ind: [],
    tmTrendMapY2ind: [],
    // 国际分类Top10
    icTop10MapXind: [],
    icTop10MapYind: [],
    icRegTop10MapXind: [],
    icRegTop10MapYind: [],
    // 商标分析榜单
    topApp10MapXind: [],
    topApp10MapYind: [],
    topReg10MapXind: [],
    topReg10MapYind: [],
    topValid10MapXind: [],
    topValid10MapYind: [],
    // 商标状态分析
    lawMapind: [],
    // 商标转让趋势
    tmTransferMapYind: [],
    // 商标转让类别Top10
    tmIcTrfTopXind: [],
    tmIcTrfTopYind: [],
    // 商标许可趋势
    tmLicenseMapYind: [],
    // 商标许可类别Top10
    tmIcLicTopXind: [],
    tmIcLicTopYind: [],
    // 商标质押趋势
    tmPledgeMapYind: [],
    // 商标质押类别Top10
    tmIcPldTopXind: [],
    tmIcPldTopYind: [],
    // 商标运营分析榜单
    tmTrfTop10Xind: [],
    tmTrfTop10Yind: [],
    tmLicTop10Xind: [],
    tmLicTop10Yind: [],
    tmPldTop10Xind: [],
    tmPldTop10Yind: [],
    // 马德里商标趋势
    mdltrendYind: [],
    // 马德里延伸国家TOP20
    mdltop20indX: [],
    mdltop20indY: [],
    // 马德里注册量Top10
    mdlregindY: [],
    mdlregindX: [],
    ///////////////重点产业结束/////////////

  },
  mutations: {
    // 商标数据
    tdDataDetails(state, payload) {
      state.sbbasicDataDetails = payload
    },
    // 报告数据
    ReportDataDetail(state, payload) {
      state.ReportDataDetails = payload
    },
    // 专利数据
    zlDataDetails(state, payload) {
      state.zlbasicDataDetails = payload
    },
    // 企业数据
    enterDetails(state, payload) {
      state.enterbasicDataDetails = payload
    },
    // 用户信息
    getUser(state, payload) {},
    // 企业分析
    keyFirmdataszl(state, payload) {
      state.trendTime = payload.time
    },
    keyGNzl(state, payload) {
      // state.trendTime = payload.time
      // 国内专利趋势
      state.trendApListYapply = []
      state.trendApListYagree = []
      payload.trendApList.forEach(ele => {
        state.trendApListYapply.push(ele.num)
        state.trendApListYagree.push(ele.num2)
      });
      // console.log(state.trendApListYapply)
      // console.log(state.trendApListYagree)
      // 专利类型构成
      payload.apTyCount.forEach((item, index) => {
        payload.apTyCount[index]["value"] = item.num;
      });
      payload.apTyAuthCount.forEach((item, index) => {
        payload.apTyAuthCount[index]["value"] = item.num;
      });
      state.apTyCount = payload.apTyCount;
      state.apTyAuthCount = payload.apTyAuthCount;
      // 专利分析榜单
      state.appTop10X = [];
      state.appTop10Y = [];
      payload.appTop10.forEach((ele) => {
        state.appTop10X.push(ele.num);
        state.appTop10Y.push(ele.name);
      });
      state.authTop10X = [];
      state.authTop10Y = [];
      payload.authTop10.forEach((ele) => {
        state.authTop10X.push(ele.num);
        state.authTop10Y.push(ele.name);
      });

      state.validTop10X = [];
      state.validTop10Y = [];
      payload.validTop10.forEach((ele) => {
        state.validTop10X.push(ele.num);
        state.validTop10Y.push(ele.name);
      });

      state.notValidTop10X = [];
      state.notValidTop10Y = [];
      payload.notValidTop10.forEach((ele) => {
        state.notValidTop10X.push(ele.num);
        state.notValidTop10Y.push(ele.name);
      });
      // IPC技术分类top10
      state.ipcCountX = [];
      state.ipcCountY = [];
      payload.ipcCount.forEach((ele) => {
        state.ipcCountX.push(ele.num);
        ele.name = ele.code + '-' + ele.name
        state.ipcCountY.push(ele.name);
      });
      state.ipcAuthCountX = [];
      state.ipcAuthCountY = [];
      payload.ipcAuthCount.forEach((ele) => {
        state.ipcAuthCountX.push(ele.num);
        ele.name = ele.code + '-' + ele.name
        state.ipcAuthCountY.push(ele.name);
      });
    },

    PCTAndStatuszl(state, payload) {
      // PCT公开量Top10
      state.pctTop10CountX = [];
      state.pctTop10CountY = [];
      payload.pctTop10Count.forEach((ele) => {
        state.pctTop10CountX.push(ele.num);
        state.pctTop10CountY.push(ele.name);
      });
      // 专利状态分析
      payload.ptLawCount.forEach((item, index) => {
        payload.ptLawCount[index]["value"] = item.num;
      });
      state.ptLawCount = payload.ptLawCount;
      // IPC分类top10
      state.pctIpcTop10X = [];
      state.pctIpcTop10Y = [];
      payload.pctIpcTop10.forEach((ele) => {
        state.pctIpcTop10X.push(ele.num);
        ele.name = ele.code + '-' + ele.name
        state.pctIpcTop10Y.push(ele.name);
      });
      // PCT专利趋势
      state.pctTrendCountX = [];
      state.pctTrendCountY = [];
      payload.pctTrendCount.forEach((ele) => {
        state.pctTrendCountX.push(ele.name);
        state.pctTrendCountY.push(ele.num);
      });
    },
    keyGNsb(state, payload) {
      // 国内商标趋势
      state.tmTrendMapY1 = [];
      state.tmTrendMapY2 = [];
      payload.tmTrendMap.forEach((ele) => {
        state.tmTrendMapY1.push(ele.num);
        state.tmTrendMapY2.push(ele.num2);
      });
      // 国际分类Top10
      state.icTop10MapX = [];
      state.icTop10MapY = [];
      state.icRegTop10MapX = [];
      state.icRegTop10MapY = [];
      payload.icTop10Map.forEach((ele) => {
        state.icTop10MapX.push(ele.num);
        state.icTop10MapY.push(ele.IC);
      });
      payload.icRegTop10Map.forEach((ele) => {
        state.icRegTop10MapX.push(ele.num);
        state.icRegTop10MapY.push(ele.IC);
      });
      // 商标分析榜单
      state.topApp10MapX = [];
      state.topApp10MapY = [];
      state.topReg10MapX = [];
      state.topReg10MapY = [];
      state.topValid10MapX = [];
      state.topValid10MapY = [];
      payload.topApp10Map.forEach((ele) => {
        state.topApp10MapX.push(ele.num);
        state.topApp10MapY.push(ele.name);
      });
      payload.topReg10Map.forEach((ele) => {
        state.topReg10MapX.push(ele.num);
        state.topReg10MapY.push(ele.name);
      });
      payload.topValid10Map.forEach((ele) => {
        state.topValid10MapX.push(ele.num);
        state.topValid10MapY.push(ele.name);
      })
    },
    mdlAndStatus(state, payload) {
      // 商标状态分析
      payload.lawMap.forEach((item, index) => {
        payload.lawMap[index]["value"] = item.num;
        payload.lawMap[index]["name"] = item.ls;
      });
      state.lawMap = payload.lawMap;
      // 马德里商标趋势
      state.mdltrendY = [];
      payload.madridTrend.forEach(ele => {
        state.mdltrendY.push(ele.num)
      });
      // 马德里延伸国家TOP20
      state.mdltop20X = [];
      state.mdltop20Y = [];
      payload.madridExtendTop20.forEach(ele => {
        state.mdltop20X.push(ele.name)
        state.mdltop20Y.push(ele.num)
      });
      // 马德里注册量Top10
      state.mdlregY = [];
      state.mdlregX = [];
      payload.madridTop10.forEach(ele => {
        state.mdlregY.push(ele.name)
        state.mdlregX.push(ele.num)
      });
    },
    Yunysb(state, payload) {
      // 商标转让趋势
      state.tmTransferMapY = [];
      payload.tmTransferMap.forEach((ele) => {
        state.tmTransferMapY.push(ele.num);
      });
      // 商标转让类别Top10
      state.tmIcTrfTopX = [];
      state.tmIcTrfTopY = [];
      payload.tmIcTrfTop.forEach((ele) => {
        state.tmIcTrfTopX.push(ele.num);
        state.tmIcTrfTopY.push(ele.name);
      });
      // 商标许可趋势
      state.tmLicenseMapY = [];
      payload.tmLicenseMap.forEach((ele) => {
        state.tmLicenseMapY.push(ele.num);
      });
      // 商标许可类别Top10
      state.tmIcLicTopX = [];
      state.tmIcLicTopY = [];
      payload.tmIcLicTop.forEach((ele) => {
        state.tmIcLicTopX.push(ele.num);
        state.tmIcLicTopY.push(ele.name);
      });
      // 商标质押趋势
      state.tmPledgeMapY = [];
      payload.tmPledgeMap.forEach((ele) => {
        state.tmPledgeMapY.push(ele.num);
      });
      // 商标质押类别Top10
      state.tmIcPldTopX = [];
      state.tmIcPldTopY = [];
      payload.tmIcPldTop.forEach((ele) => {
        state.tmIcPldTopX.push(ele.num);
        state.tmIcPldTopY.push(ele.name);
      });
      // 商标运营分析榜单
      state.tmTrfTop10X = [];
      state.tmTrfTop10Y = [];
      payload.tmTrfTop10.forEach((ele) => {
        state.tmTrfTop10X.push(ele.num);
        state.tmTrfTop10Y.push(ele.name);
      });
      state.tmLicTop10X = [];
      state.tmLicTop10Y = [];
      payload.tmLicTop10.forEach((ele) => {
        state.tmLicTop10X.push(ele.num);
        state.tmLicTop10Y.push(ele.name);
      });
      state.tmPldTop10X = [];
      state.tmPldTop10Y = [];
      payload.tmPldTop10.forEach((ele) => {
        state.tmPldTop10X.push(ele.num);
        state.tmPldTop10Y.push(ele.name);
      });
    },
    // 专利分析 
    getzldatas(state, payload) {
      // debugger;
      state.trendTimezl = payload.time
      // 国内专利趋势
      state.trendApListzlY1 = []
      state.trendApListzlY2 = []
      // console.log(payload.trendApList)
      payload.trendApList.forEach(ele => {
        state.trendApListzlY1.push(ele.num);
        state.trendApListzlY2.push(ele.num2);
      })
      // 专利类型构成
      payload.apTyCount.forEach((ele, index) => {
        payload.apTyCount[index]['value'] = ele.num
      })
      payload.apTyAuthCount.forEach((ele, index) => {
        payload.apTyAuthCount[index]['value'] = ele.num
      })
      state.apTyCountzl = payload.apTyCount
      // console.log('state.apTyCountzl',state.apTyCountzl)
      state.apTyAuthCountzl = payload.apTyAuthCount
      // 申请人构成及趋势
      state.jggroup = []
      state.dzschool = []
      state.sciencedw = []
      state.gkcompany = []
      state.single = []
      payload.apTyTrendCount.forEach(ele => {
        state.jggroup.push(ele["机关团体"])
        state.dzschool.push(ele["大专院校"])
        state.sciencedw.push(ele["科研单位"])
        state.gkcompany.push(ele["工矿企业"])
        state.single.push(ele["个人"])
      })
      state.jggroupAuth = []
      state.dzschoolAuth = []
      state.sciencedwAuth = []
      state.gkcompanyAuth = []
      state.singleAuth = []
      payload.apTyAuthTrendCount.forEach(ele => {
        state.jggroupAuth.push(ele["机关团体"])
        state.dzschoolAuth.push(ele["大专院校"])
        state.sciencedwAuth.push(ele["科研单位"])
        state.gkcompanyAuth.push(ele["工矿企业"])
        state.singleAuth.push(ele["个人"])
      })
      // IPC技术分类Top10
      state.ipcCountXzl = [];
      state.ipcCountYzl = [];
      payload.ipcCount.forEach((ele) => {
        state.ipcCountXzl.push(ele.num);
        ele.name = ele.code + '-' + ele.name
        state.ipcCountYzl.push(ele.name);
      });
      state.ipcAuthCountXzl = [];
      state.ipcAuthCountYzl = [];
      payload.ipcAuthCount.forEach((ele) => {
        state.ipcAuthCountXzl.push(ele.num);
        ele.name = ele.code + ' ' + ele.name
        state.ipcAuthCountYzl.push(ele.name);
      });
      // 有效专利权利人分布
      // state.jggroupYX = []
      // state.dzschoolYX = []
      // state.sciencedwYX = []
      // state.gkcompanyYX = []
      // state.singleYX = []
      // 发明有效专利申请人分布
      payload.apValidInv.forEach((item, index) => {
        payload.apValidInv[index]["value"] = item.num;
      });
      state.apValid = payload.apValidInv;
      // 实用新型有效专利申请人分布
      payload.utilityValidInv.forEach((item, index) => {
        payload.utilityValidInv[index]["value"] = item.num;
      });
      state.utilityValidInvzl = payload.utilityValidInv;

      // 实用新型有效专利申请人分布
      payload.designValidInv.forEach((item, index) => {
        payload.designValidInv[index]["value"] = item.num;
      });
      state.designValidInvzl = payload.designValidInv;
      state.jggroupAuthYX = []
      state.dzschoolAuthYX = []
      state.sciencedwAuthYX = []
      state.gkcompanyAuthYX = []
      state.singleAuthYX = []
      payload.apTyAuthValidInvCount.forEach(ele => {
        state.jggroupAuthYX.push(ele["机关团体"])
        state.dzschoolAuthYX.push(ele["大专院校"])
        state.sciencedwAuthYX.push(ele["科研单位"])
        state.gkcompanyAuthYX.push(ele["工矿企业"])
        state.singleAuthYX.push(ele["个人"])
      })
    },
    getzlTop(state, payload) {
      state.appTop10Xzl = []
      state.appTop10Yzl = []
      payload.appTop10.forEach(ele => {
        state.appTop10Xzl.push(ele.num)
        state.appTop10Yzl.push(ele.name)
      })
      // 专利质押登记量趋势 专利核准转让量趋势 专利许可备案量趋势
      // patentPledgeOneX:[],
      // patentPledgeOneY:[],
      // patentAssignmentsTwoX:[],
      // patentAssignmentsTwoY:[],
      // patentlicensethreeX:[],
      // patentlicensethreeY:[],

      // state.patentPledgeOneX= []
      state.patentPledgeOneY = []
      payload.zyTrend.forEach(ele => {
        // state.patentPledgeOneX.push(ele.time)
        state.patentPledgeOneY.push(ele.num)
      })

      // state.patentAssignmentsTwoX = []
      state.patentAssignmentsTwoY = []
      payload.zrTrend.forEach(ele => {
        // state.patentAssignmentsTwoX.push(ele.time)
        state.patentAssignmentsTwoY.push(ele.num)
      })

      // state.patentlicensethreeX = []
      state.patentlicensethreeY = []
      payload.xkTrend.forEach(ele => {
        // state.patentlicensethreeX.push(ele.time)
        state.patentlicensethreeY.push(ele.num)
      })


      state.validTop10Xzl = []
      state.validTop10Yzl = []
      payload.validTop10.forEach(ele => {
        state.validTop10Xzl.push(ele.num)
        state.validTop10Yzl.push(ele.name)
      })

      state.authTop10Xzl = []
      state.authTop10Yzl = []
      payload.authTop10.forEach(ele => {
        state.authTop10Xzl.push(ele.num)
        state.authTop10Yzl.push(ele.name)
      })

      state.notValidTop10Xzl = []
      state.notValidTop10Yzl = []
      payload.notValidTop10.forEach(ele => {
        state.notValidTop10Xzl.push(ele.num)
        state.notValidTop10Yzl.push(ele.name)
      })
    },
    pctPublic(state, payload) {
      // PCT专利趋势
      state.pctTrendCountYzl = []
      payload.pctTrendCount.forEach(ele => {
        state.pctTrendCountYzl.push(ele.num)
      })
      // console.log('state.pctTrendCountYzl',state.pctTrendCountYzl)
      // ipc分类
      state.pctIpcTop10Xzl = [];
      state.pctIpcTop10Yzl = [];
      payload.pctIpcTop10.forEach((ele) => {
        state.pctIpcTop10Xzl.push(ele.num);
        ele.name = ele.code + '-' + ele.name
        state.pctIpcTop10Yzl.push(ele.name);
      });
      // PCT公开量Top10
      state.pctTop10CountXzl = [];
      state.pctTop10CountYzl = [];
      payload.pctTop10Count.forEach((ele) => {
        state.pctTop10CountXzl.push(ele.num);
        state.pctTop10CountYzl.push(ele.name);
      });
    },
    zlStatusAnaly(state, payload) {
      payload.ptLawCount.forEach((item, index) => {
        payload.ptLawCount[index]["value"] = item.num;
      });
      state.ptLawCountzl = payload.ptLawCount;
    },
    zlRegionCompare(state, payload) {
      state.ApplyXzl = []
      state.ApplyFM = []
      state.ApplySY = []
      state.ApplyWG = []
      payload.areaApplyTrendCount.forEach(ele => {
        state.ApplyXzl.push(ele.cnty)

        state.ApplyFM.push(ele['发明'])
        state.ApplySY.push(ele['实用新型'])
        state.ApplyWG.push(ele['外观设计'])
      });

      state.AuthXzl = []
      state.AuthFM = []
      state.AuthSY = []
      state.AuthWG = []
      payload.areaAuthTrendCount.forEach(ele => {
        state.AuthXzl.push(ele.cnty)
        state.AuthFM.push(ele['发明'])
        state.AuthSY.push(ele['实用新型'])
        state.AuthWG.push(ele['外观设计'])
      });

      state.pctXzl = []
      state.pctFM = []
      state.pctSY = []
      payload.areaPctTrendCount.forEach(ele => {
        state.pctXzl.push(ele.cnty)
        state.pctFM.push(ele['PCT发明'])
        state.pctSY.push(ele['PCT实用新型'])
      });

      state.wxXzl = []
      state.wxFM = []
      state.wxSY = []
      state.wxWG = []
      payload.areaValidTrendCount.forEach(ele => {
        state.wxXzl.push(ele.cnty)
        state.wxFM.push(ele['发明'])
        state.wxSY.push(ele['实用新型'])
        state.wxWG.push(ele['外观设计'])
      });

    },
    // 商标分析
    getsbdatas(state, payload) {
      state.trendTimesb = payload.time
      // 国内商标趋势
      state.trendApListsbY1 = []
      state.trendApListsbY2 = []
      payload.tmTrendMap.forEach(ele => {
        state.trendApListsbY1.push(ele.num);
        state.trendApListsbY2.push(ele.num2);
      })
      // 国际分类Top10
      state.icTop10MapsbX = []
      state.icTop10MapsbY = []
      state.icRegTop10MapsbX = []
      state.icRegTop10MapsbY = []
      payload.icTop10Map.forEach(ele => {
        state.icTop10MapsbX.push(ele.num)
        state.icTop10MapsbY.push(ele.IC)
      });
      payload.icRegTop10Map.forEach(ele => {
        state.icRegTop10MapsbX.push(ele.num)
        state.icRegTop10MapsbY.push(ele.IC)
      })
      // 申请人构成及趋势
      state.jggroupsb = []
      state.dzschoolsb = []
      state.sciencedwsb = []
      state.gkcompanysb = []
      state.singlesb = []
      payload.apTyTrendForm.forEach(ele => {
        state.jggroupsb.push(ele["机关团体"])
        state.dzschoolsb.push(ele["大专院校"])
        state.sciencedwsb.push(ele["科研单位"])
        state.gkcompanysb.push(ele["工矿企业"])
        state.singlesb.push(ele["个人"])
      })
      state.jggroupAuthsb = []
      state.dzschoolAuthsb = []
      state.sciencedwAuthsb = []
      state.gkcompanyAuthsb = []
      state.singleAuthsb = []
      payload.apTyAuthTrendForm.forEach(ele => {
        state.jggroupAuthsb.push(ele["机关团体"])
        state.dzschoolAuthsb.push(ele["大专院校"])
        state.sciencedwAuthsb.push(ele["科研单位"])
        state.gkcompanyAuthsb.push(ele["工矿企业"])
        state.singleAuthsb.push(ele["个人"])
      })
    },
    getsbTop(state, payload) {
      state.topApp10MapXsb = [];
      state.topApp10MapYsb = [];
      state.topReg10MapXsb = [];
      state.topReg10MapYsb = [];
      state.topValid10MapXsb = [];
      state.topValid10MapYsb = [];
      payload.topApp10Map.forEach((ele) => {
        state.topApp10MapXsb.push(ele.num);
        state.topApp10MapYsb.push(ele.name);
      });
      payload.topReg10Map.forEach((ele) => {
        state.topReg10MapXsb.push(ele.num);
        state.topReg10MapYsb.push(ele.name);
      });
      payload.topValid10Map.forEach((ele) => {
        state.topValid10MapXsb.push(ele.num);
        state.topValid10MapYsb.push(ele.name);
      });
    },
    getsbTwo(state, payload) {
      // 商标状态分析
      payload.lawMap.forEach((item, index) => {
        payload.lawMap[index]["value"] = item.num;
        payload.lawMap[index]["name"] = item.ls;
      });
      state.lawMapSb = payload.lawMap;
      // 区域
      state.areaTmCompMapX = []
      state.areaTmCompMapY = []
      payload.areaTmCompMap.forEach(ele => {
        state.areaTmCompMapX.push(ele.name)
        state.areaTmCompMapY.push(ele.num)
      })
      state.areaRegTmCompMapX = []
      state.areaRegTmCompMapY = []
      payload.areaRegTmCompMap.forEach(ele => {
        state.areaRegTmCompMapX.push(ele.name)
        state.areaRegTmCompMapY.push(ele.num)
      })
      state.areaMadridTmCompMapX = []
      state.areaMadridTmCompMapY = []
      payload.areaMadridTmCompMap.forEach(ele => {
        state.areaMadridTmCompMapX.push(ele.name)
        state.areaMadridTmCompMapY.push(ele.num)
      })
    },
    getsbyunying(state, payload) {
      state.tmTransferMapYsb = [];
      payload.tmTransferMap.forEach((ele) => {
        state.tmTransferMapYsb.push(ele.num);
      });
      state.tmIcTrfTopXsb = [];
      state.tmIcTrfTopYsb = [];
      payload.tmIcTrfTop.forEach((ele) => {
        state.tmIcTrfTopXsb.push(ele.num);
        state.tmIcTrfTopYsb.push(ele.name);
      });

      state.tmLicenseMapYsb = [];
      payload.tmLicenseMap.forEach((ele) => {
        state.tmLicenseMapYsb.push(ele.num);
      });
      state.tmIcLicTopXsb = [];
      state.tmIcLicTopYsb = [];
      payload.tmIcLicTop.forEach((ele) => {
        state.tmIcLicTopXsb.push(ele.num);
        state.tmIcLicTopYsb.push(ele.name);
      });

      state.tmPledgeMapYsb = [];
      payload.tmPledgeMap.forEach((ele) => {
        state.tmPledgeMapYsb.push(ele.num);
      });
      state.tmIcPldTopXsb = [];
      state.tmIcPldTopYsb = [];
      payload.tmIcPldTop.forEach((ele) => {
        state.tmIcPldTopXsb.push(ele.num);
        state.tmIcPldTopYsb.push(ele.name);
      });
    },
    sbyunytop(state, payload) {
      state.tmTrfTop10Xsb = [];
      state.tmTrfTop10Ysb = [];
      payload.tmTrfTop10.forEach((ele) => {
        state.tmTrfTop10Xsb.push(ele.num);
        state.tmTrfTop10Ysb.push(ele.name);
      });
      state.tmLicTop10Xsb = [];
      state.tmLicTop10Ysb = [];
      payload.tmLicTop10.forEach((ele) => {
        state.tmLicTop10Xsb.push(ele.num);
        state.tmLicTop10Ysb.push(ele.name);
      });
      state.tmPldTop10Xsb = [];
      state.tmPldTop10Ysb = [];
      payload.tmPldTop10.forEach((ele) => {
        state.tmPldTop10Xsb.push(ele.num);
        state.tmPldTop10Ysb.push(ele.name);
      });
    },
    regionService(state, payload) {
      payload.agentDist.forEach((item, index) => {
        payload.agentDist[index]['value'] = item.num
      })
      state.agentDist = payload.agentDist
      state.agentTmTop10X = []
      state.agentTmTop10Y = []
      payload.agentTmTop10.forEach(ele => {
        state.agentTmTop10X.push(ele.num)
        state.agentTmTop10Y.push(ele.AG)
      });
      payload.malice.forEach((item, index) => {
        payload.malice[index]['value'] = item.num
      })
      state.malice = payload.malice;
      state.maliceAppTmTop10X = []
      state.maliceAppTmTop10Y = []
      payload.maliceAppTmTop10.forEach(ele => {
        state.maliceAppTmTop10X.push(ele.num)
        state.maliceAppTmTop10Y.push(ele.ap)
      });
    },
    mdlsb(state, payload) {
      // 马德里商标趋势
      state.mdltrendYsb = [];
      payload.madridTrend.forEach(ele => {
        state.mdltrendYsb.push(ele.num)
      });
      // 马德里延伸国家TOP20
      state.mdltop20Xsb = [];
      state.mdltop20Ysb = [];
      payload.madridExtendTop20.forEach(ele => {
        state.mdltop20Xsb.push(ele.name)
        state.mdltop20Ysb.push(ele.num)
      });
      // 马德里注册量Top10
      state.mdlregYsb = [];
      state.mdlregXsb = [];
      payload.madridTop10.forEach(ele => {
        state.mdlregYsb.push(ele.name)
        state.mdlregXsb.push(ele.num)
      });
    },
    // 重点产业
    keyFirmdataszlind(state, payload) {
      state.trendTimeind = payload.time
    },
    // 首页专利数据
    ptApplydata(state, payload) {
      // console.log('payload',payload)
      // 月份
      // state.ptApplydataYagreeind = []
      state.ptApplydataYapplyind = []
      payload.ptApply.forEach((ele) => {
        // state.ptApplydataYagreeind.push(ele.month)
        state.ptApplydataYapplyind.push(ele.num)

      })
      state.ptApplydataYagreeind = []
      state.ptAuthorizationLine = []
      // 国内专利授权趋势
      payload.ptTable.forEach((ele) => {
        state.ptApplydataYagreeind.push(ele.month)
      })

      payload.ptAuthorization.forEach((ele) => {

        state.ptAuthorizationLine.push(ele.num)
      })
      // 国内商标申请趋势
      state.tmApplyMonth = []
      state.tmApplyNum = []
      payload.tmApply.forEach((ele) => {
        // state.tmApplyMonth.push(ele.month)
        state.tmApplyNum.push(ele.num)
      })
      payload.tmTable.forEach((ele) => {
        state.tmApplyMonth.push(ele.month)
      })
      // console.log('tmApplyMonth',state.tmApplyMonth)
      // console.log('state.tmApplyNum',state.tmApplyNum)
      // 国内商标注册趋势
      state.tmRegNum = []
      payload.tmReg.forEach((ele) => {
        state.tmRegNum.push(ele.num)
      })
      // console.log('state.tmRegNum',state.tmRegNum)
      // 商标国际注册量TOP10

      state.tmIcRegIc = []
      state.tmIcRegNum = []
      payload.tmIcReg.forEach((e) => {
        state.tmIcRegIc.push(e.ic)
        state.tmIcRegNum.push(e.num)
      })
      // console.log('---',state.tmIcApplyIc,state.tmIcApplyNum)
      state.tmIcApplyIc = []
      state.tmIcApplyNum = []
      payload.tmIcApply.forEach(e => {
        state.tmIcApplyIc.push(e.ic)
        state.tmIcApplyNum.push(e.num)
      })
      // console.log('---',state.tmIcRegNum)

    },
    keyGNzlind(state, payload) {
      // state.trendTime = payload.time
      // 国内专利趋势
      state.trendApListYapplyind = []
      state.trendApListYagreeind = []
      payload.trendApList.forEach(ele => {
        state.trendApListYapplyind.push(ele.num)
        state.trendApListYagreeind.push(ele.num2)
      });
      // 专利类型构成
      payload.apTyCount.forEach((item, index) => {
        payload.apTyCount[index]["value"] = item.num;
      });
      payload.apTyAuthCount.forEach((item, index) => {
        payload.apTyAuthCount[index]["value"] = item.num;
      });
      state.apTyCountind = payload.apTyCount;
      state.apTyAuthCountind = payload.apTyAuthCount;
      // console.log(state.apTyCountind)
      // console.log(state.apTyAuthCount)
      // 专利分析榜单
      state.appTop10Xind = [];
      state.appTop10Yind = [];
      payload.appTop10.forEach((ele) => {
        state.appTop10Xind.push(ele.num);
        state.appTop10Yind.push(ele.name);
      });
      state.authTop10Xind = [];
      state.authTop10Yind = [];
      payload.authTop10.forEach((ele) => {
        state.authTop10Xind.push(ele.num);
        state.authTop10Yind.push(ele.name);
      });

      state.validTop10Xind = [];
      state.validTop10Yind = [];
      payload.validTop10.forEach((ele) => {
        state.validTop10Xind.push(ele.num);
        state.validTop10Yind.push(ele.name);
      });

      state.notValidTop10Xind = [];
      state.notValidTop10Yind = [];
      payload.notValidTop10.forEach((ele) => {
        state.notValidTop10Xind.push(ele.num);
        state.notValidTop10Yind.push(ele.name);
      });
      // IPC技术分类top10
      state.ipcCountXind = [];
      state.ipcCountYind = [];
      payload.ipcCount.forEach((ele) => {
        state.ipcCountXind.push(ele.num);
        ele.name = ele.code + '-' + ele.name
        state.ipcCountYind.push(ele.name);
      });
      state.ipcAuthCountXind = [];
      state.ipcAuthCountYind = [];
      payload.ipcAuthCount.forEach((ele) => {
        state.ipcAuthCountXind.push(ele.num);
        ele.name = ele.code + '-' + ele.name
        state.ipcAuthCountYind.push(ele.name);
      });
    },
    PCTAndStatuszlind(state, payload) {
      // PCT公开量Top10
      state.pctTop10CountXind = [];
      state.pctTop10CountYind = [];
      payload.pctTop10Count.forEach((ele) => {
        state.pctTop10CountXind.push(ele.num);
        state.pctTop10CountYind.push(ele.name);
      });
      // 专利状态分析
      payload.ptLawCount.forEach((item, index) => {
        payload.ptLawCount[index]["value"] = item.num;
      });
      state.ptLawCountind = payload.ptLawCount;
      // IPC分类top10
      state.pctIpcTop10Xind = [];
      state.pctIpcTop10Yind = [];
      payload.pctIpcTop10.forEach((ele) => {
        state.pctIpcTop10Xind.push(ele.num);
        ele.name = ele.code + '-' + ele.name
        state.pctIpcTop10Yind.push(ele.name);
      });
      // PCT专利趋势
      state.pctTrendCountXind = [];
      state.pctTrendCountYind = [];
      payload.pctTrendCount.forEach((ele) => {
        state.pctTrendCountXind.push(ele.name);
        state.pctTrendCountYind.push(ele.num);
      });
      // console.log('state.pctTrendCountYind',state.pctTrendCountYind)
    },
    keyGNsbind(state, payload) {
      // 国内商标趋势
      state.tmTrendMapY1ind = [];
      state.tmTrendMapY2ind = [];
      payload.tmTrendMap.forEach((ele) => {
        state.tmTrendMapY1ind.push(ele.num);
        state.tmTrendMapY2ind.push(ele.num2);
      });
      // 国际分类Top10
      state.icTop10MapXind = [];
      state.icTop10MapYind = [];
      state.icRegTop10MapXind = [];
      state.icRegTop10MapYind = [];
      payload.icTop10Map.forEach((ele) => {
        state.icTop10MapXind.push(ele.num);
        state.icTop10MapYind.push(ele.IC);
      });
      payload.icRegTop10Map.forEach((ele) => {
        state.icRegTop10MapXind.push(ele.num);
        state.icRegTop10MapYind.push(ele.IC);
      });
      // 商标分析榜单
      state.topApp10MapXind = [];
      state.topApp10MapYind = [];
      state.topReg10MapXind = [];
      state.topReg10MapYind = [];
      state.topValid10MapXind = [];
      state.topValid10MapYind = [];
      payload.topApp10Map.forEach((ele) => {
        state.topApp10MapXind.push(ele.num);
        state.topApp10MapYind.push(ele.name);
      });
      payload.topReg10Map.forEach((ele) => {
        state.topReg10MapXind.push(ele.num);
        state.topReg10MapYind.push(ele.name);
      });
      payload.topValid10Map.forEach((ele) => {
        state.topValid10MapXind.push(ele.num);
        state.topValid10MapYind.push(ele.name);
      })
    },
    mdlAndStatusind(state, payload) {
      // 商标状态分析
      payload.lawMap.forEach((item, index) => {
        payload.lawMap[index]["value"] = item.num;
        payload.lawMap[index]["name"] = item.ls;
      });
      state.lawMapind = payload.lawMap;
      // 马德里商标趋势
      state.mdltrendYind = [];
      payload.madridTrend.forEach(ele => {
        state.mdltrendYind.push(ele.num)
      });
      // 马德里延伸国家TOP20
      state.mdltop20indX = [];
      state.mdltop20indY = [];
      payload.madridExtendTop20.forEach(ele => {
        state.mdltop20indX.push(ele.name)
        state.mdltop20indY.push(ele.num)
      });
      // 马德里注册量Top10
      state.mdlregindY = [];
      state.mdlregindX = [];
      payload.madridTop10.forEach(ele => {
        state.mdlregindY.push(ele.name)
        state.mdlregindX.push(ele.num)
      });
    },
    Yunysbind(state, payload) {
      // 商标转让趋势
      state.tmTransferMapYind = [];
      payload.tmTransferMap.forEach((ele) => {
        state.tmTransferMapYind.push(ele.num);
      });
      // 商标转让类别Top10
      state.tmIcTrfTopXind = [];
      state.tmIcTrfTopYind = [];
      payload.tmIcTrfTop.forEach((ele) => {
        state.tmIcTrfTopXind.push(ele.num);
        state.tmIcTrfTopYind.push(ele.name);
      });
      // 商标许可趋势
      state.tmLicenseMapYind = [];
      payload.tmLicenseMap.forEach((ele) => {
        state.tmLicenseMapYind.push(ele.num);
      });
      // 商标许可类别Top10
      state.tmIcLicTopXind = [];
      state.tmIcLicTopYind = [];
      payload.tmIcLicTop.forEach((ele) => {
        state.tmIcLicTopXind.push(ele.num);
        state.tmIcLicTopYind.push(ele.name);
      });
      // 商标质押趋势
      state.tmPledgeMapYind = [];
      payload.tmPledgeMap.forEach((ele) => {
        state.tmPledgeMapYind.push(ele.num);
      });
      // 商标质押类别Top10
      state.tmIcPldTopXind = [];
      state.tmIcPldTopYind = [];
      payload.tmIcPldTop.forEach((ele) => {
        state.tmIcPldTopXind.push(ele.num);
        state.tmIcPldTopYind.push(ele.name);
      });
      // 商标运营分析榜单
      state.tmTrfTop10Xind = [];
      state.tmTrfTop10Yind = [];
      payload.tmTrfTop10.forEach((ele) => {
        state.tmTrfTop10Xind.push(ele.num);
        state.tmTrfTop10Yind.push(ele.name);
      });
      state.tmLicTop10Xind = [];
      state.tmLicTop10Yind = [];
      payload.tmLicTop10.forEach((ele) => {
        state.tmLicTop10Xind.push(ele.num);
        state.tmLicTop10Yind.push(ele.name);
      });
      state.tmPldTop10Xind = [];
      state.tmPldTop10Yind = [];
      payload.tmPldTop10.forEach((ele) => {
        state.tmPldTop10Xind.push(ele.num);
        state.tmPldTop10Yind.push(ele.name);
      });
    },
    logout(state) {
      localStorage.setItem('token', '')
      window.location.reload()
    }
  },
  actions: {},
  modules: {
    tab
  }
})